import { nab } from '@nab/nui-themes-web';
import base from '../themes';
export default base(nab);